import {
	Palette,
	HandHeart,
	Hourglass,
	RefreshCcw,
	Shield,
	PartyPopper,
	Rainbow,
	Lock,
	BookOpen,
	Smile,
	Target,
	Puzzle,
	Scale,
	Handshake,
	Search,
	MessageCircle,
	Sparkles,
	Star,
	TrendingUp,
	Wrench,
	Globe,
	Zap,
	MessageSquare,
	Ruler,
	Microscope,
	Lightbulb,
	Sun,
	Flame,
	Users,
	Folder,
	Map,
	Rocket,
	Check,
	Unlock,
	Link,
	Sprout,
	Brain,
	Bolt,
	Octagon,
	Meh,
	Frown,
	DoorClosed,
	CircleHelp,
	Cloud,
	Ear,
	Calendar,
	HeartCrack,
	MessageCircleOff,
	Shell,
	BatteryLow,
	RefreshCwOff,
	EyeOff,
	MessageCircleDashed,
	ZapOff,
	Link2Off,
	SearchX,
	PencilOff,
	MapPinOff,
	Trash2,
	ArrowRightLeft,
	Expand,
	BringToFront,
	HandCoins,
	Tornado,
	LockKeyholeOpen,
	ArrowDownFromLine,
	Pause,
	UserPen,
	CircleUserRound,
	BicepsFlexed,
	ScanEye,
	Blend,
	HeartHandshake,
	ShieldHalf,
	Eye,
	Waves,
	Megaphone,
	Trophy,
	Diamond,
	Compass,
	Anchor,
	RedoDot,
	Rabbit,
	OctagonX,
	Clock2,
	ListOrdered,
	Laugh,
	Gauge,
	Tally5,
	Hand,
	Paintbrush,
	ThumbsUp,
	Book,
	Heart,
	Clock,
	BarChart,
	MapPin,
	Gift,
	Award,
	Leaf,
	HandHelping,
	UserCheck,
	UserPlus,
	Slash,
	User,
	Sliders,
	StopCircle,
	Recycle,
	Wifi,
	Crown,
	DoorOpen,
	Medal,
	CircleFadingPlus,
	CircleGauge,
	SpellCheck,
	Maximize2,
	View,
	ReplaceAll,
	MessageSquareHeart,
	ShieldEllipsis,
	FileText,
	GitBranch,
	HardHat,
	Mail,
	TrendingDown,
	GraduationCap,
	BadgePlus,
	CircleArrowOutUpRight,
	Drum,
	MessagesSquare,
	SignpostBig,
	Merge,
	ToyBrick,
	WrapText,
	School,
	CalendarCheck,
	UsersRound,
	Briefcase,
	Share2,
	DiamondPlus,
	CalendarClock,
	Atom,
	RefreshCw,
	ArrowDown,
	CalendarRange,
} from 'lucide-static';

export const wordIconData = [
	{ name: 'Afspraak is afspraak', icon: Ruler },
	{ name: 'Afspraken nakomen', icon: CalendarCheck },
	{ name: 'Altijd actief meedoen', icon: Gauge },
	{ name: 'Altijd de angst overwinnen', icon: Shield },
	{ name: 'Altijd een stap vooruit zetten', icon: RedoDot },
	{ name: 'Altijd positief blijven', icon: Rainbow },
	{ name: 'Altijd volledig betrokken zijn', icon: Link },
	{ name: 'Altijd vooruit denken', icon: Clock2 },
	{ name: 'Analytisch', icon: Search },
	{ name: 'Anderen echt begrijpen', icon: Handshake },
	{ name: 'Anderen helpen richting te geven', icon: Compass },
	{ name: 'Anderen oprecht steunen', icon: HeartHandshake },
	{ name: 'Angst voor het onbekende', icon: CircleHelp },
	{ name: 'Assertief', icon: MessageSquare },
	{ name: 'Avontuurlijk', icon: Map },
	{ name: 'Balans tussen werk en ontspanning', icon: Scale },
	{ name: 'Balans tussen werk en rust', icon: Scale },
	{ name: 'Behulpzaam', icon: Users },
	{ name: 'Besluiteloos', icon: ArrowRightLeft },
	{ name: 'Betrokken', icon: Link },
	{ name: 'Betrokkenheid vergroten', icon: Link },
	{ name: 'Betrokkenheid', icon: Link },
	{ name: 'Betrouwbaar', icon: Lock },
	{ name: 'Chaos in planning', icon: Calendar },
	{ name: 'Chaotisch', icon: Shell },
	{ name: 'Charismatisch', icon: Star },
	{ name: 'Communicatie verbeteren', icon: MessageCircle },
	{ name: 'Communicatie', icon: MessageCircle },
	{ name: 'Communicatief sterk', icon: MessageCircle },
	{ name: 'Conflictbeheersing', icon: HeartHandshake },
	{ name: 'Conflicten als groeikans zien', icon: Handshake },
	{ name: 'Conflicten constructief oplossen', icon: Puzzle },
	{ name: 'Constructievere feedback', icon: ThumbsUp },
	{ name: 'Continu leren', icon: Book },
	{ name: 'Creatief', icon: Palette },
	{ name: 'Creativiteit stimuleren', icon: Paintbrush },
	{ name: 'Creativiteit', icon: Paintbrush },
	{ name: 'De focus leggen op samen sterker', icon: ShieldHalf },
	{ name: 'Delen van kennis', icon: Book },
	{ name: 'Diversiteit', icon: Globe },
	{ name: 'Doelbewuste planning', icon: MapPin },
	{ name: 'Doelen beter afstemmen', icon: Target },
	{ name: 'Doelgericht', icon: Target },
	{ name: 'Doelloos', icon: Target },
	{ name: 'Duidelijk grenzen aangeven', icon: OctagonX },
	{ name: 'Duidelijk weten wie wat doet', icon: SignpostBig },
	{ name: 'Duidelijke doelen', icon: Target },
	{ name: 'Duidelijke rolverdeling', icon: UserPlus },
	{ name: 'Duidelijke visie communiceren', icon: GitBranch },
	{ name: 'Duurzame samenwerking', icon: Leaf },
	{ name: 'Eenvoudigere processen', icon: Recycle },
	{ name: 'Eerlijk zeggen wat er speelt', icon: MessagesSquare },
	{ name: 'Eerlijke verdeling van taken', icon: Scale },
	{ name: 'Eerlijkere werkverdeling', icon: Scale },
	{ name: 'Eerst denken, dan handelen', icon: Brain },
	{ name: 'Effectieve vergaderingen', icon: Calendar },
	{ name: 'Effectievere besluitvorming', icon: BarChart },
	{ name: 'Efficiënt', icon: Zap },
	{ name: 'Efficiënter tijdbeheer', icon: Hourglass },
	{ name: 'Efficiëntie', icon: Zap },
	{ name: 'Elkaar aanmoedigen', icon: Drum },
	{ name: 'Elkaar helpen waar je goed in bent', icon: GraduationCap },
	{ name: 'Elkaar uitdagen om beter te worden', icon: WrapText },
	{ name: 'Empathie vergroten', icon: Heart },
	{ name: 'Empathie', icon: Heart },
	{ name: 'Empathisch', icon: HandHeart },
	{ name: 'Enthousiasme', icon: Smile },
	{ name: 'Enthousiast', icon: PartyPopper },
	{ name: 'Feedback geven die helpt', icon: Mail },
	{ name: 'Financiële onzekerheid', icon: HandCoins },
	{ name: 'Flexibel blijven', icon: RefreshCcw },
	{ name: 'Flexibel', icon: RefreshCcw },
	{ name: 'Flexibiliteit vergroten', icon: Maximize2 },
	{ name: 'Flexibiliteit', icon: RefreshCcw },
	{ name: 'Focus op groeien', icon: Sprout },
	{ name: 'Focus op resultaat', icon: ScanEye },
	{ name: 'Fouten als leermomenten', icon: SpellCheck },
	{ name: 'Gebalanceerde werkdruk', icon: CircleGauge },
	{ name: 'Gebrek aan grenzen', icon: BringToFront },
	{ name: 'Gebrek aan motivatie', icon: BatteryLow },
	{ name: 'Weinig waardering voor details', icon: Star },
	{ name: 'Gedreven', icon: Flame },
	{ name: 'Geduldig', icon: Hourglass },
	{ name: 'Geef snel op', icon: Octagon },
	{ name: 'Geen visie', icon: EyeOff },
	{ name: 'Gelijkwaardige behandeling', icon: Scale },
	{ name: 'Geloven in mezelf', icon: Star },
	{ name: 'Georganiseerd', icon: Folder },
	{ name: 'Gericht blijven op het doel', icon: Target },
	{ name: 'Gestroomlijnde kennisdeling', icon: Share2 },
	{ name: 'Gezondere competitie', icon: Medal },
	{ name: 'Goed samenwerken als een team', icon: ToyBrick },
	{ name: 'Goede besluitvorming', icon: BarChart },
	{ name: 'Goede communicatie', icon: MessageCircle },
	{ name: 'Graag anderen ondersteunen', icon: HandHeart },
	{ name: 'Grenzen respecteren', icon: HardHat },
	{ name: 'Groeien in wat je doet', icon: Star },
	{ name: 'Groots durven dromen', icon: Cloud },
	{ name: 'Heldere communicatiekanalen', icon: Wifi },
	{ name: 'Heldere doelen maken', icon: Target },
	{ name: 'Heldere verwachtingen', icon: Star },
	{ name: 'Humor', icon: Laugh },
	{ name: 'Humoristisch', icon: Smile },
	{ name: 'Ideeën uitwisselen', icon: Star },
	{ name: 'Iedereen doet mee', icon: Handshake },
	{ name: 'Iedereen doet zijn best', icon: CircleGauge },
	{ name: 'Iedereen erbij betrekken', icon: Link },
	{ name: 'Iedereen mee laten tellen', icon: Tally5 },
	{ name: 'Iedereen waardevol vinden', icon: Diamond },
	{ name: 'Iedereen wordt gelijk behandeld', icon: UsersRound },
	{ name: 'Initiatief nemen', icon: TrendingUp },
	{ name: 'Innovatie', icon: DiamondPlus },
	{ name: 'Innovatief', icon: Lightbulb },
	{ name: 'Inspiratie delen', icon: Sparkles },
	{ name: 'Inspirerend', icon: Sparkles },
	{ name: 'Integer', icon: Scale },
	{ name: 'Kalm blijven onder grote druk', icon: Waves },
	{ name: 'Kansen altijd benutten', icon: Star },
	{ name: 'Kennis en tips delen', icon: School },
	{ name: 'Leergierig', icon: BookOpen },
	{ name: 'Leren van fouten', icon: Search },
	{ name: 'Loyaliteit', icon: Crown },
	{ name: 'Luisteren naar elkaar', icon: Ear },
	{ name: 'Luisteren', icon: Ear },
	{ name: 'Meer lachen en verbinden', icon: Smile },
	{ name: 'Meer passie uitstralen', icon: CircleUserRound },
	{ name: 'Meer transparantie', icon: Search },
	{ name: 'Meningen beter horen', icon: Ear },
	{ name: 'Met passie doelen behalen', icon: Target },
	{ name: 'Mezelf duidelijk en krachtig uiten', icon: Megaphone },
	{ name: 'Middelen beter benutten', icon: Book },
	{ name: 'Mijzelf beter aanpassen', icon: UserPen },
	{ name: 'Minder micromanagement', icon: Sliders },
	{ name: 'Misverstanden voorkomen', icon: Slash },
	{ name: 'Moeilijk benaderbaar', icon: DoorClosed },
	{ name: 'Moeite met loslaten', icon: Link2Off },
	{ name: 'Moeite met samenwerken', icon: Handshake },
	{ name: 'Motivatie aanwakkeren', icon: Rocket },
	{ name: 'Motivatie', icon: Rocket },
	{ name: 'Motiverende beloningen', icon: Gift },
	{ name: 'Nauwkeurig', icon: Microscope },
	{ name: 'Netjes en professioneel werken', icon: User },
	{ name: 'Niet creatief genoeg', icon: PencilOff },
	{ name: 'Niet durven veranderen', icon: RefreshCwOff },
	{ name: 'Niet flexibel', icon: Ruler },
	{ name: 'Niet goed luisteren', icon: Ear },
	{ name: 'Niet inspirerend', icon: Sparkles },
	{ name: 'Niet nauwkeurig', icon: Ruler },
	{ name: 'Nieuwe ideeën bedenken', icon: Lightbulb },
	{ name: 'Nieuwe ideeën delen', icon: Lightbulb },
	{ name: 'Nieuwsgierig zijn', icon: Search },
	{ name: 'Omgaan met verandering', icon: RefreshCcw },
	{ name: 'Ondernemend', icon: Rocket },
	{ name: 'Ondersteuning', icon: HandHelping },
	{ name: 'Onderwaardering van jezelf', icon: ArrowDownFromLine },
	{ name: 'Ongeorganiseerd', icon: Folder },
	{ name: 'Ongevoelig', icon: HeartCrack },
	{ name: 'Onrealistische verwachtingen', icon: Rainbow },
	{ name: 'Onverschillig', icon: Meh },
	{ name: 'Onzeker', icon: MessageCircleDashed },
	{ name: 'Op elk detail letten', icon: Microscope },
	{ name: 'Open-minded', icon: Globe },
	{ name: 'Openheid', icon: Search },
	{ name: 'Oplossingsgericht', icon: Puzzle },
	{ name: 'Optimistisch zijn', icon: Sun },
	{ name: 'Optimistisch', icon: Sun },
	{ name: 'Overal op zoek gaan naar verbinding', icon: Globe },
	{ name: 'Overbelasting voorkomen', icon: StopCircle },
	{ name: 'Passief', icon: Pause },
	{ name: 'Patronen wat scherper zien', icon: Eye },
	{ name: 'Perfectionisme', icon: Sparkles },
	{ name: 'Perfectionistisch', icon: Ruler },
	{ name: 'Persoonlijke groei stimuleren', icon: Sprout },
	{ name: 'Positief', icon: Rainbow },
	{ name: 'Positieve complimenten geven', icon: ThumbsUp },
	{ name: 'Positieve feedback', icon: ThumbsUp },
	{ name: 'Positieve sfeer', icon: Sun },
	{ name: 'Positievere houdingen', icon: Smile },
	{ name: 'Praktisch ingesteld', icon: Wrench },
	{ name: 'Proactief', icon: TrendingUp },
	{ name: 'Probleemoplossend vermogen', icon: Puzzle },
	{ name: 'Problemen creatief oplossen', icon: Puzzle },
	{ name: 'Problemen rustig oplossen', icon: GitBranch },
	{ name: 'Productievere vergaderingen', icon: Calendar },
	{ name: 'Professioneel gedrag stimuleren', icon: Briefcase },
	{ name: 'Realistisch plannen', icon: TrendingUp },
	{ name: 'Realistische oplossingen vinden', icon: Wrench },
	{ name: 'Realistischere verwachtingen', icon: Star },
	{ name: 'Respect hebben voor elkaar', icon: Hand },
	{ name: 'Respect laten groeien', icon: Hand },
	{ name: 'Respect voor deadlines', icon: Clock },
	{ name: 'Respect', icon: Hand },
	{ name: 'Resultaatgerichtheid', icon: Target },
	{ name: 'Riscomijdend', icon: Expand },
	{ name: 'Risico’s bespreken en aanpakken', icon: TrendingDown },
	{ name: 'Rollen duidelijk verdelen', icon: UserCheck },
	{ name: 'Ruimte geven voor creativiteit', icon: Paintbrush },
	{ name: 'Samen iets nieuws bedenken', icon: BadgePlus },
	{ name: 'Samen kansen zien', icon: Globe },
	{ name: 'Samen kijken wat beter kan', icon: Merge },
	{ name: 'Samen problemen oplossen', icon: Puzzle },
	{ name: 'Samen vieren van successen', icon: Gift },
	{ name: 'Samenwerking versterken', icon: CircleFadingPlus },
	{ name: 'Samenwerking', icon: Handshake },
	{ name: 'Scherpere focus', icon: View },
	{ name: 'Zwakke communicatie', icon: MessageCircleOff },
	{ name: 'Slechte timing', icon: Hourglass },
	{ name: 'Slimme beslissingen nemen', icon: BarChart },
	{ name: 'Slordig in details', icon: Microscope },
	{ name: 'Slordig', icon: Trash2 },
	{ name: 'Snel en effectief handelen', icon: Rabbit },
	{ name: 'Snel gestrest', icon: ZapOff },
	{ name: 'Snelle en nuttige vergaderingen', icon: Calendar },
	{ name: 'Soepelere veranderingen', icon: ReplaceAll },
	{ name: 'Sterkere teamdynamiek', icon: ShieldEllipsis },
	{ name: 'Stimuleren van persoonlijke groei', icon: Sprout },
	{ name: 'Strakkere planning', icon: CalendarRange },
	{ name: 'Strategisch', icon: Brain },
	{ name: 'Stressbestendig', icon: Bolt },
	{ name: 'Streven naar excellentie', icon: Trophy },
	{ name: 'Successen samen vieren', icon: PartyPopper },
	{ name: 'Taken eerlijk verdelen', icon: Scale },
	{ name: 'Te afhankelijk van anderen', icon: Handshake },
	{ name: 'Te negatief ingesteld', icon: Cloud },
	{ name: 'Te weinig ambitie', icon: Flame },
	{ name: 'Teamspeler', icon: Handshake },
	{ name: 'Technologie gebruiken om beter te werken', icon: Atom },
	{ name: 'Tijd goed plannen', icon: Hourglass },
	{ name: 'Tijdmanagement', icon: CalendarClock },
	{ name: 'Toegankelijk', icon: Unlock },
	{ name: 'Toegankelijkere ondersteuning', icon: DoorOpen },
	{ name: 'Toewijding', icon: Link },
	{ name: 'Transparant zijn', icon: Blend },
	{ name: 'Trouw blijven aan mijn waarden', icon: Anchor },
	{ name: 'Vaker lachen', icon: Laugh },
	{ name: 'Vaker orde in de chaos creëren', icon: ListOrdered },
	{ name: 'Vaker waardering tonen', icon: MessageSquareHeart },
	{ name: 'Vanuit mijn eigen kracht presteren', icon: BicepsFlexed },
	{ name: 'Vastberaden zijn op mijn doel', icon: Shield },
	{ name: 'Vastberaden', icon: Shield },
	{ name: 'Veerkrachtig', icon: Sprout },
	{ name: 'Veranderingen beter begeleiden', icon: Wrench },
	{ name: 'Veranderingen samen aanpakken', icon: CircleArrowOutUpRight },
	{ name: 'Verantwoordelijkheid delen', icon: GitBranch },
	{ name: 'Verantwoordelijkheid nemen', icon: Shield },
	{ name: 'Verlies van richting', icon: MapPinOff },
	{ name: 'Vertrouwen hebben in elkaar', icon: Lock },
	{ name: 'Vertrouwen versterken', icon: Lock },
	{ name: 'Vertrouwen', icon: Lock },
	{ name: 'Vertrouwensproblemen', icon: LockKeyholeOpen },
	{ name: 'Waardering tonen', icon: Award },
	{ name: 'Warm en benaderbaar zijn', icon: Flame },
	{ name: 'Weinig analytisch vermogen', icon: SearchX },
	{ name: 'Weinig veerkracht', icon: Frown },
	{ name: 'Werkplezier', icon: Smile },
	{ name: 'Weten wat je van elkaar verwacht', icon: FileText },
	{ name: 'Wispelturig', icon: Tornado },
	{ name: 'Zaken zonder oordeel bekijken', icon: Scale },
	{ name: 'Zelfverzekerd', icon: Check },
	{ name: 'Zorgen voor plezier', icon: PartyPopper },
	{ name: 'Zinvolheid', icon: Lightbulb },
	{ name: 'Vastberaden', icon: Target },
	{ name: 'Resultaatgericht', icon: TrendingUp },
	{ name: 'Veerkrachtig', icon: RefreshCw },
	{ name: 'Weinig veerkracht', icon: ArrowDown },
	{ name: 'Verlies van energie', icon: BatteryLow },
	// { name: '', icon: X },
];

// Lookup by Lucide icon name string (as stored in custom preset words).
// Keys must match names listed in `pickableIconNames` in shared.
export const iconByName: Record<string, string> = {
	Palette,
	HandHeart,
	Hourglass,
	RefreshCcw,
	RefreshCw,
	Shield,
	PartyPopper,
	Rainbow,
	Lock,
	Unlock,
	BookOpen,
	Book,
	Smile,
	Frown,
	Meh,
	Target,
	Puzzle,
	Scale,
	Handshake,
	HandHelping,
	HeartHandshake,
	Heart,
	HeartCrack,
	Search,
	MessageCircle,
	MessageSquare,
	Megaphone,
	Sparkles,
	Star,
	TrendingUp,
	TrendingDown,
	Wrench,
	Globe,
	Zap,
	ZapOff,
	Ruler,
	Lightbulb,
	Brain,
	Sun,
	Cloud,
	Flame,
	Users,
	User,
	UsersRound,
	Map,
	MapPin,
	Compass,
	Rocket,
	Check,
	Link,
	Sprout,
	Leaf,
	Award,
	Medal,
	Trophy,
	Crown,
	Gift,
	Clock,
	Calendar,
	CalendarCheck,
	Anchor,
	ThumbsUp,
	ShieldHalf,
	Eye,
	EyeOff,
	DoorOpen,
	DoorClosed,
	ArrowRightLeft,
	CircleHelp,
	Bolt,
	Trash2,
	GraduationCap,
	Briefcase,
};

export function resolveWordIcon(name: string | undefined, iconOverride?: string): string | undefined {
	if (iconOverride && iconByName[iconOverride]) return iconByName[iconOverride];
	if (!name) return undefined;
	return wordIconData.find((w) => w.name === name)?.icon;
}
